import React from "react";
import RecentlyViewedCard from "../BannerManager/RecentlyViewedCard";
import "../../styles/pages/Banners/BannerManager.scss";

export default React.memo(function GotoRecentlyViewed(props) {
  const {
    setBannerDetails,
    getSearchedTemplates,
    docIdVeeva,
    oneTimeDocNumbers,
  } = props;
  return (
    <>
      {props.responseData.map((recentlyViewedData, index) => {
        const hasExplicitOneTimeFlag =
          typeof recentlyViewedData?.oneTimeAsset === "boolean";
        const isOneTime = hasExplicitOneTimeFlag
          ? recentlyViewedData.oneTimeAsset
          : oneTimeDocNumbers?.has?.(recentlyViewedData?.damDocNumber) || false;
        const cardKey =
          recentlyViewedData?.id ||
          recentlyViewedData?.damDocNumber ||
          recentlyViewedData?.assetName ||
          `recent-card-${index}`;
        return (
          <div className="recentlyCardsCol " key={cardKey}>
            <RecentlyViewedCard
              isOneTime={isOneTime}
              docIdVeeva={docIdVeeva}
              setBannerDetails={setBannerDetails}
              bannerDetails={props.bannerDetails}
              recentlyViewedData={recentlyViewedData}
              search={props.search}
              createdByMe={props.createdByMe}
              removeSearchresultCard={props.removeSearchresultCard}
              setLoading={props.setLoading}
              generateRVCV={props.generateRVCV}
              disableProceedbut={props.disableProceedbut}
              setDisableProceedbut={props.setDisableProceedbut}
              selectMultipleBanner={props.selectMultipleBanner}
              setSelectMultipleBanner={props.setSelectMultipleBanner}
              arrcheckboxSelection={props.arrcheckboxSelection}
              setArrcheckboxSelection={props.setArrcheckboxSelection}
              indexResponseData={index}
              responseData={props.responseData}
              genericInfo={props.genericInfo}
              setGenericInfo={props.setGenericInfo}
              isAnimatedBanner={props.isAnimatedBanner}
              hide3dotIcon={props.hide3dotIcon}
              fetchAllTemplates={props.fetchAllTemplates}
              lockUnlockBannerAtFE={props.lockUnlockBannerAtFE}
              setCurrentPage={props.setCurrentPage}
              getSearchedTemplates={getSearchedTemplates}
            />
          </div>
        );
      })}
    </>
  );
});
